import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { blogKey } from "../shared/baseUrl";
import Ai from "../assets/img/Ai.jpg";
import Ai2 from "../assets/img/Banking.jpg";
import Ai3 from "../assets/img/OutSourcing.jpeg";

const Blogs = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [posts, setPosts] = useState([]);

  const images = [Ai, Ai2, Ai3]; // Predefined images

  const settings = {
    dots: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 500,
    centerMode: true,
    beforeChange: (_, next) => setActiveIndex(next),
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
    className: "slick-track",
  };

  useEffect(() => {
    fetch(
      `https://www.googleapis.com/blogger/v3/blogs/2425642010638613354/posts?key=${blogKey}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.items) {
          const updatedPosts = data.items.map((post, index) => ({
            ...post,
            image: post.images
              ? post.images[0].url
              : images[index % images.length],
          }));
          setPosts(updatedPosts);
        } else {
          console.error("No posts found");
        }
      })
      .catch((error) => console.error("Error fetching posts:", error));
  }, [images]);

  return (
    <div className="game-section">
      <Slider {...settings} className="owl-carousel custom-carousel owl-theme">
        {posts.map((game, index) => (
          <div
            key={index}
            className={`item ${index === activeIndex ? "active" : ""}`}>
            <div
              className="game-card"
              style={{
                backgroundImage: `url(${game.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "10px",
                display: "flex",
                alignItems: "flex-end",
                padding: "20px",
                color: "#fff",
              }}>
              <div
                className="item-desc"
                style={{
                  padding: "10px",
                  borderRadius: "5px",
                  marginBottom: "40px",
                }}>
                <h5>{game.title}</h5>
                <a href={game.url} target="_blank" rel="noopener noreferrer">
                  <p style={{ color: "#f04217" }}>Read More</p>
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Blogs;
